import { render, staticRenderFns } from "./ListaBollettini.vue?vue&type=template&id=49f7c727"
import script from "./ListaBollettini.vue?vue&type=script&lang=js"
export * from "./ListaBollettini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports